import React, { Fragment, useRef } from 'react';
import { ToastProvider } from 'react-toast-notifications';
import { Form } from 'react-bootstrap';
import language from '../../config/es';
//redux
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../redux/store/hooks';
import {
  getPermissions,
  findBySocieties,
  findRawBranches,
  updateBranch,
  saveBranch,
  deleteBranch,
} from '../../redux/branch.duck';
import { findCountries } from '../../redux/society.duck';
//Permissions
import dictionary from '../../config/dictionary';
//Session user
import SessionConfig from '../../config/session_config';
//Crud compartido
import {
  useCrudState,
  usePermissionGate,
} from '../../components/Crud/crudHooks';
import {
  buildEditColumn,
  fetchRows,
  renderDeleteAction,
  requireSelection,
  requireValues,
  saveActionOf,
  stampRows,
} from '../../components/Crud/crudHelpers';
import {
  CountrySelect,
  RequiredFieldsAlertLegacy,
  SelectField,
  TextField,
} from '../../components/Crud/CrudFields';
import {
  CrudButtons,
  CrudDataTable,
  CrudLoadingScreen,
  CrudPage,
  WIDE_TABLE_COLS,
} from '../../components/Crud/CrudLayout';

const Branch = () => {
  //#region variable
  const ref = useRef();
  const dispatch = useAppDispatch();

  const {
    data,
    refreshState,
    updateState,
    viewNotification,
    handleSelectRow,
    initStateDelete,
    reloadWith,
    finishDelete,
    prepareSave,
  } = useCrudState({
    collectionEntity: { value: 0, label: '', error: '', auth: '' },
    country: { value: 0, label: '', error: '', auth: '' },
    showloadingEntity: true,
    showloadingCountry: false,
    pendingData: false,
    enable: true,
    name: { value: '', error: '' },
    address: { value: '', error: '' },
    phone: { value: '', error: '' },
    code: { value: '', error: '' },
    dataRows: [],
    errors: [],
    columns: [],
    entities: [],
    countries: [],
    selectedRows: [],
    id: null,
    showDelete: false,
    action: dictionary.configApp.action,
    auth: JSON.parse(sessionStorage.getItem('user')),
  });
  data.entities = useSelector((store) => store.branchReducer.cEntities);
  data.collectionEntity.auth = useSelector(
    (store) => store.branchReducer.errorResponse
  );
  data.country.auth = useSelector((store) => store.branchReducer.errorResponse);
  data.countries = useSelector((store) => store.societyReducer.countries);
  data.dataRows = useSelector((store) => store.branchReducer.branches);
  //#endregion
  //ciclo de vida ---------------------------------------------------
  const { loadInit, msgRestricted, withPermission } = usePermissionGate({
    ref,
    data,
    dispatch,
    getPermissions,
    notify: viewNotification,
    onAllowed: () => {
      initColumns();
      void initData();
    },
  });
  //#region  handlers
  const updateSelect = async (value, id) => {
    switch (id) {
      case 'collectionEntity':
        data.collectionEntity = value;
        data.pendingData = true;
        await loadBranches();
        data.pendingData = false;
        initColumns();
        break;
      case 'country':
        data.id = -1;
        data.country = value;
        data.collectionEntity = { value: 0, label: '', error: '', auth: '' };
        data.dataRows = [];
        updateState(false, 'showloadingEntity');
        await loadEntities();
        data.id = null;
        data.showloadingEntity = true;
        initColumns();
        break;
      default:
        break;
    }
    refreshState();
  };
  const onChange = (event) => {
    switch (event.target.name) {
      case 'name':
        data.name.value = event.target.value;
        data.name.error = '';
        break;
      case 'phone':
        data.phone.value = event.target.value;
        data.phone.error = '';
        break;
      case 'address':
        data.address.value = event.target.value;
        data.address.error = '';
        break;
      case 'code':
        data.code.value = event.target.value;
        data.code.error = '';
        break;
      default:
        break;
    }
    refreshState();
  };
  const handleButtonEdit = (row) => {
    data.id = row.id;
    data.showloadingCountry = true;
    data.name.value = row.name;
    data.address.value = row.address;
    data.phone.value = row.phone;
    data.code.value = row.code === undefined || row.code===null ? '' : row.code;

    refreshState();
  };
  //#endregion
  //#region functions
  const initColumns = () => {
    data.columns = [
      buildEditColumn(handleButtonEdit, { width: '50px' }),
      {
        name: language.messages.lblName,
        sortable: false,
        wrap: true,
        width: '250px',
        cell: (row) => (
          <span>
            <div className=" text-uppercase small">{row.name}</div>
            <div className="badge badge-info">
              {language.messages.branch.lblCod}: {row.code}
            </div>
          </span>
        ),
      },
      {
        name: language.messages.branch.lbl_address,
        sortable: false,
        wrap: true,
        width: '250px',
        cell: (row) => (
          <span>
            <div className=" text-uppercase small">{row.address}</div>
            <div className=" text-uppercase text-primary small">
              <b className="text-dark">{language.messages.branch.lbl_phone}</b>{' '}
              {row.phone}
            </div>
          </span>
        ),
      },
    ];
    refreshState();
  };
  const clearError = () => {
    data.errors = [];
    data.country.error = '';
    data.collectionEntity.error = '';
    data.phone.error = '';
    data.address.error = '';
    data.name.error = '';
  };
  const validate = () => {
    clearError();
    requireSelection(data, ['country', 'collectionEntity']);
    requireValues(data, ['name', 'phone', 'address', 'code']);
    refreshState();
  };
  const loadBranches = async () => {
    updateState(true, 'pendingData');
    data.dataRows = await fetchRows(
      () => dispatch(findRawBranches(data.collectionEntity.value)),
      viewNotification
    );

    updateState(false, 'pendingData');
  };
  const reloadData = () => reloadWith(loadBranches);
  const clearForm = () => {
    data.name = { value: '', error: '' };
    data.phone = { value: '', error: '' };
    data.address = { value: '', error: '' };
    data.code = { value: '', error: '' };

    data.id = null;
    refreshState();
  };
  const notifySaveError = (message) => {
    updateState(true, 'enable');
    viewNotification(message, 'error');
  };
  const handleSaveResponse = async (response) => {
    if (response.status !== 200) {
      notifySaveError(
        response.data === 'EXIST'
          ? language.messages.codeDuplicated
          : response.messageResponse
      );
      return;
    }
    updateState(true, 'pendingData');
    await reloadData();
    viewNotification(language.messages.msmRegisterSuccessFully, 'success');
    clearForm();
    updateState(false, 'pendingData');
  };
  const saveData = async () => {
    prepareSave(validate);
    await withPermission(saveActionOf(data), async () => {
      if (data.errors.length === 0) {

        let json = {
          id: data.id,
          name: data.name.value,
          phone: data.phone.value,
          address: data.address.value,
          code: data.code.value,
          status: 1,
          userAdmin: sessionStorage.getItem('username'),
          societyId: data.country.value.toUpperCase(),
          centity: { id: data.collectionEntity.value },
        };

        let response = '';
        if (data.id === null) {
          response = await dispatch(saveBranch(json));
        } else {
          response = await dispatch(updateBranch(json));
        }

        await handleSaveResponse(response);
      }
    });
  };
  const disableData = async () => {
    data.enable=false;
    refreshState();
    if (data.selectedRows.length > 0) {
      await withPermission(data.action.delete, async () => {
        stampRows(data.selectedRows, { authUser: data.auth.id.user.id });
        initStateDelete(false);

        let response = await dispatch(deleteBranch(data.selectedRows));
        finishDelete(response.status === 200, response.message, reloadData);
      });
    }
  };
  const cleaningForm = () => {
    clearForm();
    clearError();
  };
  const reloadDataEnable = () => {
    void loadBranches();
  };
  const initData = async () => {
    await loadCountries();
  };
  const loadEntities = async () => {
    data.showloadingEntity = false;
    await dispatch(findBySocieties(data.country.value));
    updateState(true, 'showloadingEntity');
  };
  const loadCountries = async () => {
    await dispatch(findCountries(data.auth.id.user.userId));
    updateState(true, 'showloadingCountry');
  };

  const contextActions = renderDeleteAction(disableData, data.enable);
  //#endregion
  return (
    <Fragment>
      <br />
      <SessionConfig ref={ref} />
      {loadInit === true ? (
        <CrudLoadingScreen msgRestricted={msgRestricted} />
      ) : (
        <CrudPage
          {...WIDE_TABLE_COLS}
          formTitle={language.messages.branch.title}
          form={
            <Form autoComplete="off">
              <RequiredFieldsAlertLegacy />
              <CountrySelect
                data={data}
                col={{ md: 12 }}
                onChange={updateSelect}
              />
              <SelectField
                row
                col={{ md: 12 }}
                label={language.messages.titleCEntityForm}
                loading={data.showloadingEntity}
                isDisabled={data.id !== null}
                name="collectionEntity"
                options={data.entities}
                field={data.collectionEntity}
                showAuth
                onChange={updateSelect}
                changeKey="collectionEntity"
              />
              <TextField
                row
                col={{ md: 12 }}
                label={language.messages.lblName}
                name="name"
                field={data.name}
                onChange={onChange}
              />
              <TextField
                row
                col={{ md: 12 }}
                label={language.messages.branch.lbl_phone}
                name="phone"
                field={data.phone}
                onChange={onChange}
              />
              <TextField
                row
                col={{ md: 12, sm: 12 }}
                label={language.messages.branch.lbl_address}
                name="address"
                field={data.address}
                onChange={onChange}
              />
              <TextField
                row
                col={{ md: 12, sm: 12 }}
                label={language.messages.lblCodeRol}
                disabled={data.id !== null}
                name="code"
                field={data.code}
                onChange={onChange}
              />
              <CrudButtons
                data={data}
                withLoading
                wrapped
                primary
                reloadIcon="fa-refresh"
                isNew={data.id === null || data.id === -1}
                onSave={saveData}
                onClear={cleaningForm}
                onReload={reloadDataEnable}
              />
            </Form>
          }
          tableTitle={language.messages.branch.title_register}
          table={
            <CrudDataTable
              data={data}
              title={
                language.messages.titleCEntityForm +
                ': ' +
                data.collectionEntity.label
              }
              rows={data.dataRows}
              scrollHeight="500px"
              onSelect={handleSelectRow}
              actions={contextActions}
            />
          }
        />
      )}
    </Fragment>
  );
};
const App = () => (
  <ToastProvider>
    <Branch />
  </ToastProvider>
);
export default App;
